import React from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import AboutMeHome from "./AboutMeHome";
import Skills from "./Skills";
import Footer from "./Footer";

const AboutMe = () => {
  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "2%",
          marginLeft: "3%",
          height: "3%",
        }}
      >
        <Sidebar />

        <div style={{ display: "block", width: "90%" }}>
          <Navbar />
          <h6 style={{ width: "90%", margin: "1% auto 0 auto" }}>
            <span style={{ color: "white" }}>Who am i?</span>
          </h6>
          <AboutMeHome  />
          <Skills/>
        </div>
      </div>
      <Footer/>
      {/* <Footer /> */}
    </>
  );
};

export default AboutMe;
